var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs-wrapper"},[_c('SfBreadcrumbs',{staticClass:"breadcrumbs container px-4",attrs:{"breadcrumbs":_vm.breadcrumbs,"data-testid":"breadcrumbs"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }